export default "__VITE_ASSET__XsG$rz5w__"